import { TENANT_AT, TENANT_COM } from 'shared/consts'

const RELEASED_NEWSLETTER_TENANTS = [TENANT_COM, TENANT_AT]

const isReleasedNewsletterTenant = (tenant: string) => {
  return RELEASED_NEWSLETTER_TENANTS.includes(tenant)
}

const isNewFlowEnabled = ({
  isNxEnabled,
  useNewsletterFlowRelease,
  useSilentNewsletterRelease,
}: {
  isNxEnabled: boolean
  useNewsletterFlowRelease: boolean
  useSilentNewsletterRelease: boolean
}) => useNewsletterFlowRelease || (isNxEnabled && useSilentNewsletterRelease)

export const isFockNewsletterReleaseFlow = ({
  isNxEnabled,
  tenant,
  useNewsletterFlowRelease = false,
  useSilentNewsletterRelease,
}: {
  isNxEnabled: boolean
  tenant: string
  useNewsletterFlowRelease?: boolean
  useSilentNewsletterRelease: boolean
}) =>
  isReleasedNewsletterTenant(tenant) ||
  isNewFlowEnabled({
    isNxEnabled,
    useNewsletterFlowRelease,
    useSilentNewsletterRelease,
  })

export const isLinkToNewsletterNewFlow = ({
  useNewsletterFlowRelease,
  tenant,
}: {
  useNewsletterFlowRelease: boolean
  tenant: string
}) => isReleasedNewsletterTenant(tenant) || useNewsletterFlowRelease
